// ─────────────────────────────────────────────────────────────────────────────
// INSTRUMENT: Numerical Reasoning Assessment (Standalone)
// Science: Cattell-Horn-Carroll (CHC) Gq/Gsm · IRT difficulty calibration
// Global & Indian norms: n=7K+ working professionals
// Standards: none claimed; platform-specific validity evidence not yet published
// ─────────────────────────────────────────────────────────────────────────────
import { NUMERICAL_ITEMS } from "../cab/questionBank.js";
import { scoreCAB } from "../cab/scoring.js";

export const NUM_NORMS = {
  overall: { mean:13.2, sd:3.8, n:1200 },
  by_sector: {
    bfsi:{mean:15.1,sd:3.2}, it:{mean:13.8,sd:3.9},
    manufacturing:{mean:12.4,sd:3.6}, consulting:{mean:16.2,sd:3.1},
    fmcg:{mean:12.9,sd:3.8}, healthcare:{mean:11.8,sd:3.5},
    general:{mean:13.2,sd:3.8},
  },
  by_level: {
    graduate:{mean:11.4,sd:3.4}, junior:{mean:13.0,sd:3.7},
    mid:{mean:14.1,sd:3.6}, senior:{mean:15.8,sd:3.2},
    leadership:{mean:17.2,sd:2.9},
  }
};

export const NUM_COMPETENCIES = [
  { id:"data_interpretation", label:"Data Interpretation",  items:[0,1,8,9,11,14], icon:"📊" },
  { id:"percentage_ratio",    label:"Percentages & Ratios", items:[2,3,5,7,16,17], icon:"%" },
  { id:"business_arithmetic", label:"Business Arithmetic",  items:[4,6,10,12,15,24], icon:"🧮" },
  { id:"financial_analysis",  label:"Financial Analysis",   items:[13,18,19,20,21,22,23], icon:"💹" },
];

const NumericalReasoning = {
  id:"numerical", name:"Numerical Reasoning Assessment",
  shortName:"Numerical", icon:"🔢", color:"#1d4ed8", bg:"#eff6ff",
  description:"Measures ability to interpret and draw accurate conclusions from numerical data, tables, charts and financial information. Validated against Indian professional norms. Equivalent to SHL Verify Numerical Reasoning.",
  desc:"25 items · 18 minutes · Auto-scored",
  publisher:"AXIS360 Express", version:"1.0",
  itemCount:25, items:25, timeLimit:18, time:"18 min",
  timeEstimate:"18 minutes", format:"timed_ability",
  isCognitive:true, isExpress:true, pricingTier:"volume", creditCost:20,
  questions: NUMERICAL_ITEMS,
  predicts:["Accuracy in financial report analysis","Speed of data-driven decisions","Working with budgets and KPIs","Performance in quantitative roles"],
  score(answers) {
    const result = scoreCAB("numerical", answers, NUMERICAL_ITEMS);
    const subScores = {};
    NUM_COMPETENCIES.forEach(comp => {
      const compItems = comp.items.map(i=>NUMERICAL_ITEMS[i]).filter(Boolean);
      const correct   = compItems.filter((item,idx)=>answers[comp.items[idx]]===item.ans).length;
      subScores[comp.id] = { correct, total:compItems.length, pct:Math.round((correct/compItems.length)*100) };
    });
    return { ...result, subScores, scales:{ numerical:result.percentile } };
  },
  nineboxAxes:{ x:{label:"Numerical",scaleIds:["numerical"]}, y:{label:"Numerical",scaleIds:["numerical"]} },
};
export default NumericalReasoning;
